import '../App.css';
import '../Css/Services.css';
import data from '../JsonFiles/Equipe.json';
import EquipeDescription from './TeamSections/EquipeDescription.js';
import PersonnelDescription from './TeamSections/PersonnelDescription.js';
import TJDescription from './TeamSections/TJDescription.js';

export default function Team() {

  return (
    <div>
      <EquipeDescription nom="Rencontrez L'équipe" title="Rencontrez l'équipe" description={data.equipe[0].description} image={data.equipe[0].image}></EquipeDescription>
      <PersonnelDescription></PersonnelDescription>
       <TJDescription></TJDescription>
    </div>
      
  );
}